// extracted by mini-css-extract-plugin
export default {"brandLogos":"BrandLogos_brandLogos__2od+f","myBrandLogosCard":"BrandLogos_myBrandLogosCard__z-s-2"};